import { render, staticRenderFns } from "./BackgroundImage.vue?vue&type=template&id=761b7ffe&lang=pug"
import script from "./BackgroundImage.vue?vue&type=script&lang=ts"
export * from "./BackgroundImage.vue?vue&type=script&lang=ts"
import style0 from "./BackgroundImage.vue?vue&type=style&index=0&id=761b7ffe&prod&module=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports